module.exports = __webpack_public_path__ + "static/media/vaerskofinal.ba458418.png";